/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useResponseUser, useTest } from '@orientaction/hooks';
import { timeCountValue } from '@orientaction/reducers';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RedesignLayout } from '../../../shared';
import { redesignTheme } from '../../../theme';
import { apiServiceNative } from '../../../../../utils/fetchNative';
import { useMinorTestCongratsStyles } from './index.styles';

const MinorTestCongrats = () => {
  const classes = useMinorTestCongratsStyles();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const { getTestResultText, resetProgress } = useTest();
  const { getResponseTestUser } = useResponseUser();

  const timeCount = useSelector(timeCountValue);

  const [text, setText] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(true);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const getData = async () => {
    setLoading(true);
    try {
      if (id) {
        const oneResponseTest = await getResponseTestUser(id);
        const textResponse = await getTestResultText(oneResponseTest.attributes.test.data.id);
        setText(textResponse);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    resetProgress(100);
  }, []);

  useEffect(() => {
    if (isRunning) {
      timerRef.current = setInterval(() => {
        setSeconds(prev => prev + 1);
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isRunning]);

  const handleViewResults = async () => {
    if (!id) return;

    setSubmitting(true);
    setIsRunning(false);
    if (timerRef.current) clearInterval(timerRef.current);

    const timePassed = seconds + timeCount.timeCount;

    try {
      const updatedRespUser = await apiServiceNative.put(`/api/response-users/${id}`, {
        data: { timePassed },
      });

      if (updatedRespUser?.data) {
        history.push(`/mes-resultats/${id}`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const renderCtaButton = () => (
    <Button
      className={classes.ctaButton}
      onClick={handleViewResults}
      disabled={submitting}
      startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : undefined}>
      Voir les résultats
    </Button>
  );

  return (
    <RedesignLayout>
      {loading ? (
        <div className={classes.loadingPage}>
          <CircularProgress style={{ color: redesignTheme.colors.primaryDark }} />
        </div>
      ) : (
        <main className={classes.page}>
          <div className={classes.contentContainer}>
            <section className={classes.card}>
              <h1 className={classes.title}>{text ? text.attributes.title : '...'}</h1>
              <div
                className={classes.description}
                dangerouslySetInnerHTML={{
                  __html: text ? text.attributes.description : '...',
                }}
              />
              {!isMobile && renderCtaButton()}
            </section>
          </div>
          {isMobile && <div className={classes.stickyFooter}>{renderCtaButton()}</div>}
        </main>
      )}
    </RedesignLayout>
  );
};

export default MinorTestCongrats;
